// lib/leasing/sourcingSelection.ts
import type { SourcingSelectionTriple } from '#types/types';

// Coerce an unknown runtime-overlay `sourcingSelection` blob into a trimmed
// { portfolioId, propertyId, unitId } triple of plain strings ('' when absent).
// Shared by the Source Center view and the kernel's setSourcingSelection so the
// read/diff shape stays identical on both sides.
export const normalizeSourcingSelection = (value: unknown): SourcingSelectionTriple => {
  const source = value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
  const normalizeId = (raw: unknown) => (typeof raw === 'string' ? raw.trim() : '');
  return {
    portfolioId: normalizeId(source.portfolioId),
    propertyId: normalizeId(source.propertyId),
    unitId: normalizeId(source.unitId),
  };
};
